import { render } from "./company-report-modal.vue?vue&type=template&id=6db3c810"
import script from "./company-report-modal.vue?vue&type=script&lang=js"
export * from "./company-report-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__